<template>
  <div>
    <v-row dense row>
      <v-col class="col-12">
        <Loader v-if="loading" text="" color="black" />
        <v-container
          class="py-3 px-0 mx-n2 hyp-methodology-listing-container"
          v-if="!loading && sections && sections.length"
        >
          <v-list width="290">
            <v-list-item-group
              v-model="selectedItem"
              active-class="hyp-methodology-active-section"
              mandatory
              eager
            >
              <v-list-group
                v-for="section in sections"
                :key="section.id"
                mandatory
                :value="section"
                @click.stop="handleSelectedSection(section)"
              >
                <template v-slot:activator>
                  <v-list-item class="pl-2 pr-1">
                    <v-list-item-icon class="mr-1">
                      <v-icon
                        v-if="(section.id === selectedSection.id)"
                        size="14"
                        color="green"
                        >fas fa-star</v-icon
                      >
                      <v-icon v-if="section.loading" size="14"
                        >fas fa-circle-notch fa-spin</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="section.label"
                        class="text-wrap"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <v-list-item
                  v-for="(subItem, subIndex) in section.items"
                  :value="subItem"
                  :key="subIndex"
                  class="ml-12"
                  @click.stop="loadItemDetails(subItem)"
                >
                  <v-list-item-title
                    v-if="subItem.title != section.label"
                    v-text="subItem.title"
                  ></v-list-item-title>
                  <v-list-item-title
                    v-if="subItem.title == section.label"
                    v-text="'Overview'"
                  ></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

import {
  getMethodologySections,
  getMethodologyByType,
} from "@/services/common/methodology.service";

const EMITTED_ACTIONS = {
  SHOW_ITEM_DETAILS: "show-item-details",
};

export default {
  name: "MethodologyListing",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  data: () => ({
    loading: false,
    sections: [],
    selectedSection: null,
    selectedItem: null,
  }),
  async mounted() {
    await this.setupMethodology();
  },
  methods: {
    async setupMethodology() {
      try {
        // get the main sections
        this.loading = true;
        this.sections = await getMethodologySections();
        await this.handleSelectedSection(this.sections[0]);
        this.loading = false;
      } catch (error) {
        console.error(
          "Error getting methodology profile data: " + JSON.stringify(error)
        );
        console.error(error);
      }
    },
    async handleSelectedSection(section) {
      if (lodashGet(section, "id")) {
        this.$set(section, "loading", true);
        const sectionContent = await getMethodologyByType(section.id);
        this.$set(section, "items", sectionContent);
        this.selectedSection = section;
        this.selectedItem = this.selectedSection.items[0];
        this.$emit(EMITTED_ACTIONS.SHOW_ITEM_DETAILS, this.selectedItem);
        this.$set(section, "loading", false);
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.methodology,
          EVENT_ACTIONS.changed,
          section.id
        );
      }
    },
    loadItemDetails(item) {
      this.selectedItem = item;
      this.$emit(EMITTED_ACTIONS.SHOW_ITEM_DETAILS, this.selectedItem);
    },
  },
};
</script>

<style scoped>
.hyp-methodology-listing-container {
  max-height: 98vh !important;
  overflow-y: auto;
}
.v-list-item.hyp-methodology-active {
  color: $primary-color;
}
</style>
